export class StepsClients {
  constructor(
    public name: string = "",
    public website: string = "",
    public active: boolean = true 
  ) {}
}